import { CERTIFICATIONS } from "../data/portfolio";

const CertificationsSection = () => (
  <section className="section-enter max-w-[1180px]">
    <div className="mb-2 flex items-baseline gap-4">
      <h2 className="font-heading text-[40px] font-medium tracking-[-0.02em]">
        Scrutineering
      </h2>
      <span className="text-[10.5px] uppercase tracking-kicker text-accent-300">
        Papers checked, signed off
      </span>
    </div>

    <p className="mb-7 max-w-[660px] text-[14.5px] text-neutral-500">
      Credentials with a public record — each one links straight to its
      verification page.
    </p>

    {CERTIFICATIONS.length === 0 ? (
      <p className="text-[13px] text-neutral-500">Credential list is being updated.</p>
    ) : (
      <div className="grid grid-cols-2 gap-3.5">
        {CERTIFICATIONS.map((c) => {
          const inner = (
            <>
              {c.image && (
                <img
                  src={c.image}
                  alt=""
                  className="h-[68px] w-[68px] shrink-0 object-contain"
                />
              )}
              <div className="flex min-w-0 flex-col gap-1">
                <h3 className="font-heading text-[17px] font-medium leading-tight tracking-[-0.01em]">
                  {c.name}
                </h3>
                <p className="text-[12.5px] text-neutral-400">
                  {c.issuer} · <span className="tabular-nums">{c.year}</span>
                </p>
                {c.credentialUrl && (
                  <span className="mt-1 text-[11px] text-accent-300 underline underline-offset-2">
                    Verify on Credly →
                  </span>
                )}
              </div>
            </>
          );
          return c.credentialUrl ? (
            <a
              key={c.name}
              href={c.credentialUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="card flex items-center gap-4 p-[22px]"
            >
              {inner}
            </a>
          ) : (
            <div key={c.name} className="card flex items-center gap-4 p-[22px]">
              {inner}
            </div>
          );
        })}
      </div>
    )}
  </section>
);

export default CertificationsSection;
